function asArray(value) {
    if (Array.isArray(value)) {
        return value;
    }

    return value === undefined ? [] : [value];
}

function rangeValue(value, key, fallback = null) {
    if (typeof value === 'number') {
        return value;
    }

    const parsed = Number(value?.[key]);

    return Number.isFinite(parsed) ? parsed : fallback;
}

export function describeTrack(track) {
    return {
        label: track.label || 'Câmera sem nome',
        settings: track.getSettings?.() || {},
        capabilities: track.getCapabilities?.() || {},
    };
}

export function mergeCameraProbe(camera, probe) {
    const { settings, capabilities } = probe;
    const maxWidth = rangeValue(
        capabilities.width,
        'max',
        Number(settings.width) || null
    );
    const maxHeight = rangeValue(
        capabilities.height,
        'max',
        Number(settings.height) || null
    );

    camera.facingMode = settings.facingMode || camera.facingMode;
    camera.width = Number(settings.width) || null;
    camera.height = Number(settings.height) || null;
    camera.maxWidth = maxWidth;
    camera.maxHeight = maxHeight;
    camera.maxPixels = (maxWidth || 0) * (maxHeight || 0);
    camera.capabilities = {
        frameRate: capabilities.frameRate || null,
        focusMode: asArray(capabilities.focusMode),
        torch: capabilities.torch === true,
        zoom: capabilities.zoom || null,
    };
}

export function normalizeTrackInfo({
    track,
    currentDeviceId,
    autofocusApplied,
    torchEnabled,
}) {
    const described = describeTrack(track);
    const { settings, capabilities } = described;
    const focusModes = asArray(capabilities.focusMode);
    const zoomMin = rangeValue(capabilities.zoom, 'min');
    const zoomMax = rangeValue(capabilities.zoom, 'max');
    const zoomStep = rangeValue(capabilities.zoom, 'step', 0.1);

    return {
        label: described.label,
        deviceId: settings.deviceId || currentDeviceId,
        settings: {
            deviceId: settings.deviceId || currentDeviceId,
            groupId: settings.groupId || null,
            facingMode: settings.facingMode || 'Não informado',
            width: settings.width || null,
            height: settings.height || null,
            frameRate: settings.frameRate || null,
            aspectRatio: settings.aspectRatio || null,
            zoom: settings.zoom ?? null,
            focusMode: settings.focusMode || null,
            torch: torchEnabled,
        },
        capabilities: {
            torch: capabilities.torch === true,
            zoom: {
                supported: (
                    zoomMin !== null
                    && zoomMax !== null
                    && zoomMax > zoomMin
                ),
                min: zoomMin,
                max: zoomMax,
                step: zoomStep,
            },
            focusModes,
            continuousAutofocus: focusModes.includes('continuous'),
            width: {
                min: rangeValue(capabilities.width, 'min'),
                max: rangeValue(capabilities.width, 'max'),
            },
            height: {
                min: rangeValue(capabilities.height, 'min'),
                max: rangeValue(capabilities.height, 'max'),
            },
            frameRate: {
                min: rangeValue(capabilities.frameRate, 'min'),
                max: rangeValue(capabilities.frameRate, 'max'),
            },
            facingModes: asArray(capabilities.facingMode),
            resolutions: {
                active: (
                    settings.width && settings.height
                        ? [{
                            width: settings.width,
                            height: settings.height,
                        }]
                        : []
                ),
                width: {
                    min: rangeValue(capabilities.width, 'min'),
                    max: rangeValue(capabilities.width, 'max'),
                },
                height: {
                    min: rangeValue(capabilities.height, 'min'),
                    max: rangeValue(capabilities.height, 'max'),
                },
            },
        },
        autofocusApplied,
    };
}
